<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="wrapper" *ngIf="gridOptions$ | async as gridOptions" appLifecycleTracker trackerName="dashboard">
    <div class="grabbing">
        <div>
            <gridstack #gridstackElement1 [options]="gridOptions.nestedGridOptions">
            </gridstack>
        </div>
    </div>
    <div class="widget-list-container mat-elevation-z7" [ngClass]="{'widget-list-container-open': widgetListOpen}">
        <div class="open-list-icon-container">
            <div class="open-list-icon-background">
                <span *ngIf="widgetListOpen" (click)="hideWidgetList()" matTooltip="{{'dashboard.widget-list.tooltip' | translate}}"
                      class="mdi mdi-chevron-double-down open-list-icon"></span>
                <span *ngIf="!widgetListOpen" (click)="showWidgetList()" matTooltip="{{'dashboard.widget-list.tooltip' | translate}}"
                      class="mdi mdi-chevron-double-up open-list-icon"></span>
            </div>
        </div>
        <div class="button-wrapper">
            <button mat-flat-button color="primary" (click)="arrange()">{{'ARRANGE' | translate}}</button>
            <button mat-flat-button color="primary" (click)="restoreDefaults()">{{'RESTORE_DEFAULTS' | translate}}</button>
        </div>
        <div class="widget-list-inner-wrapper" [ngClass]="{'widget-list-inner-wrapper-dragging': dragging}">
            <gridstack *ngIf="widgetListOpen" #palleteGridstack [options]="palletGridOptions"></gridstack>
        </div>
    </div>
</div>
